import { Component } from '@opten/gin-tonic/helpers/compiler';
import { SwiperItem } from '@opten/gin-tonic/components/swiper';

@Component({className: 'js-news-slider'})
export class NewsSliderComponent {
	private swiperItem: SwiperItem;

	constructor(private element: HTMLElement) {
		this.swiperItem = new SwiperItem(this.element, {
			scale: false,
			spacing: 40,
			vertical: false,
			mousewheel: false,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1300: {
					slidesPerView: 3,
				},
			},
			initialSlide: 0,
			navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev',
			},
		});
	}
}
